import { useDispatch, useSelector } from 'react-redux'
import type { TypedUseSelectorHook } from 'react-redux'
import type { RootState, AppDispatch } from './store'

import { userRoles } from "../Core";
import IUser from '../interface/core/IUser';
import IPagination from '../interface/core/IPagination';

import { IType } from '../interface/IType';

import IAssociation from '../interface/IAssociation';
import IMember from '../interface/IMember';
import IMembership from '../interface/IMembership';
import ISingleMembershipRequest from '../interface/ISingleMembershipRequest';
import IBulkMembershipStock from '../interface/IBulkMembershipStock';
import IBulkMembershipRequest from '../interface/IBulkMembershipRequest';
import IMembershipRequest from '../interface/IMembershipRequest';
import IEmailProvince from "../interface/IEmailProvince";
import IEmailRegion from "../interface/IEmailRegion";


import {
  ICategoriaProfessionale,
  IProfessione,
  ITipologia,
  IStatusFuorisede,
  ITipoCollaborazione,
  IAdesioneComitato,

  ISystemTableItem,
} from '@/interface/ISystemTable';



import * as defaults from "../Defaults";
import moment from 'moment/min/moment-with-locales';


moment.locale(defaults.configuration.currentLocaleDate);

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector


export const generatePaginationStateDataItem = (data: any, data_type: string) => {

  let p = {
    current_page: data.current_page,
    last_page: data.last_page,

    result: [],
    links: [],

    first_page_url: data.first_page_url,
    last_page_url: data.last_page_url,

    next_page_url: data.next_page_url,
    prev_page_url: data.prev_page_url,

    path: data.path,

    per_page: data.per_page,

    from: data.from,
    to: data.to,
    total: data.total,

    type: IType.pagination

  } as IPagination
  
  data.data 
  && data.data.length > 0 
  && data.data.map((d: any, idx: number) => {

    if(data_type == IType.user) {
      return p.result.push(generateUserStateDataItem(d));
    }
    else if(data_type == IType.association) {
      return p.result.push(generateAssociationStateDataItem(d));
    }
    else if(data_type == IType.member) {
      return p.result.push(generateMemberStateDataItem(d));
    }
    else if(data_type == IType.smr) {
      return p.result.push(generateSmrStateDataItem(d));
    }
    else if(data_type == IType.bms) {
      return p.result.push(generateBmsStateDataItem(d));
    }
    else if(data_type == IType.bmr) {
      return p.result.push(generateBmrStateDataItem(d));
    }
    else if(data_type == IType.membershipRequest) {
      return p.result.push(generateMembershipRequestStateDataItem(d));
    }
    
  })

  data.links 
  && data.links.length > 0 
  && (p.links = data.links);

  
  return p;
};

export const generateUserStateDataItem = (data: any) => {

  let i = {
    id: data.id,
    name: data.name,
    surname: data.surname,
    mobile: data.mobile,
    email: data.email,
    //password: u.password,
    //password_confirmation: string,
    
    about_me: data.about_me,
    avatar_name: data.avatar,
    
    role: data.role,
    status: data.status,

    region_id: data.region_id,
    town_id: data.town_id,
    province_id: data.province_id,

    last_action: undefined,
    authorizations: undefined,

    created_by: data.created_by,
    created_at: data.created_at,
    updated_by: data.updated_by,
    updated_at: data.updated_at,
    deleted_by: data.deleted_by,
    deleted_at: data.deleted_at,

    type: IType.user
  } as unknown as IUser


  if(data.session) {
    let last_action = data.session;
    i.last_action = last_action;
  }

  if(data.authorizations) {
    let authorizations = data.authorizations;
    i.authorizations = authorizations[0]['authorization_value'];
  }


  return i;
};

export const generateAuthStateDataItem = (data: any) => {

  let i = {
    isAuthenticated: true,
    isAdmin: data.role == userRoles.administrator
      || data.role == userRoles.hero,
    
    user: generateUserStateDataItem(data)
  }

  return i;
};

export const generateAccountStateDataItem = (data: any) => {

  let i = {

    id: data.id,
    ikey: data.ikey,

    account_name: data.account_name,
    account_surname: data.account_surname,
    
    account_fiscal_code: data.account_fiscal_code,
    account_fiscal_ref:data.account_fiscal_ref,

    account_type: data.account_type,
    account_type_detail: data.account_type_detail,
    
    status: data.status,
    note: data.note,

    account_dob: moment(data.account_dob).format(defaults.configuration.moment.formControlDateString), //data.account_dob,
    account_gender: data.account_gender,

    account_email: data.account_email,
    account_contact_number: data.account_contact_number,
    account_delegate_ikey: data.account_delegate_ikey,
    
    account_address: data.account_address,
    account_region_code: data.account_region_code,
    account_province_code: data.account_province_code,
    account_town_code: data.account_town_code,
    account_cap: data.account_cap,
    
    account_event_uid: data.account_event_uid,
    account_list_partnership: data.account_list_partnership,
    list_motion_name: data.list_motion_name,

    main_image_name: data.main_image_name,

    event_ikey: data.event_ikey,

    events: undefined,
    attachments: undefined,
    partnership_lists: undefined,

    account_delegate: {} as IAccount,
    account_substitute: {} as IAccount,

    notified_at: data.notified_at,
    notified_by: data.notified_by,

    created_by: data.created_by,
    created_at: data.created_at,
    updated_by: data.updated_by,
    updated_at: data.updated_at,
    deleted_by: data.deleted_by,
    deleted_at: data.deleted_at,

    type: IType.account
  } as unknown as IAccount

  if(data.attachments) {
    let attachments = data.attachments;
    i.attachments = attachments;
  }

  if(data.account_delegate) {
    i.account_delegate = data.account_delegate;
  }

  if(data.account_substitute) {
    i.account_substitute = data.account_substitute;
  }
  

  return i;
};

export const generateEventStateDataItem = (data: any) => {

  let i = {

    id: data.id,
    ikey: data.ikey,
    title: data.title,
    slug: data.slug,
    main_image_name: data.main_image_name,

    start_date: data.start_date,
    end_date: data.end_date,

    location: data.location,
    address: data.address,

    country_code: data.country_code,
    //countryDecoded: e.countryDecoded,
    region_code: data.region_code,
    //regionDecoded: e.regionDecoded,
    province_code: data.province_code,
    //provinceDecoded: e.provinceDecoded,
    town_code: data.town_code,
    //townDecoded: e.townDecoded,
    cap: data.cap,

    status: data.status,

    votations: [],
    accounts: [],
    partnership_lists: [],
    account_management: [],
    
    created_by: data.created_by,
    created_at: data.created_at,
    updated_by: data.updated_by,
    updated_at: data.updated_at,
    deleted_by: data.deleted_by,
    deleted_at: data.deleted_at,

    type: IType.event
  } as unknown as IEvent

  if (data.votations) {
    let votations = data.votations;
    i.votations = votations;
  }

  if (data.accounts) {
    let accounts = data.accounts;
    i.accounts = accounts;
  }

  if (data.partnership_lists) {
    let partnership_lists = data.partnership_lists;
    i.partnership_lists = partnership_lists;
  }

  if (data.account_management) {
    let account_management = data.account_management;
    i.account_management = account_management;
  }

  return i;
};

export const generateVotationStateDataItem = (data: any) => {

  let i = {

    ikey: data.ikey,
    event_ikey: data.event_ikey,
    
    registration_start: data.registration_start,
    registration_end: data.registration_end,
    location: data.location,
    description: data.description,

    status: data.status,

    event: {} as IEvent,
    
    created_by: data.created_by,
    created_at: data.created_at,
    updated_by: data.updated_by,
    updated_at: data.updated_at,
    deleted_by: data.deleted_by,
    deleted_at: data.deleted_at,

    type: IType.votation
  } as unknown as IVotation

  if (data.event) {
    let event = generateEventStateDataItem(data.event);
    i.event = event;
  }

  return i;
};

export const generateInvitationStateDataItem = (data: any) => {

  let i = {

    ikey: data.ikey,

    event_ikey: data.event_ikey,
    account_ikey: data.account_ikey,
    account_event_uid: data.account_event_uid,
    
    invitation_qrcode: data.invitation_qrcode,

    notified_by: data.notified_by,
    notified_at: data.notified_at,
    
    created_by: data.created_by,
    created_at: data.created_at,
    updated_by: data.updated_by,
    updated_at: data.updated_at,
    deleted_by: data.deleted_by,
    deleted_at: data.deleted_at,

    event: {} as IEvent,
    account: {} as IAccount,

    type: IType.invitation
  } as unknown as IInvitation

  if (data.event) {
    i.event = generateEventStateDataItem(data.event);
  }

  if (data.account) {
    i.account = generateAccountStateDataItem(data.account);
  }

  return i;
};

/*
export const generateStateDataItem = (data: any) => {

  let i = {

    id: data.id,
    ikey: data.ikey,
    title: data.title,
    slug: data.slug,
    main_image_name: data.main_image_name,

    start_date: data.start_date,
    end_date: data.end_date,

    location: data.location,
    address: data.address,

    country_code: data.country_code,
    //countryDecoded: e.countryDecoded,
    region_code: data.region_code,
    //regionDecoded: e.regionDecoded,
    province_code: data.province_code,
    //provinceDecoded: e.provinceDecoded,
    town_code: data.town_code,
    //townDecoded: e.townDecoded,
    cap: data.cap,

    status: data.status,

    votations: [],
    accounts: [],
    
    created_by: data.created_by,
    created_at: data.created_at,
    updated_by: data.updated_by,
    updated_at: data.updated_at,
    deleted_by: data.deleted_by,
    deleted_at: data.deleted_at,

    type: IType.event
  } as unknown as IEvent

  if (data.votations) {
    let votations = data.votations;
    i.votations = votations;
  }

  if (data.accounts) {
    let accounts = data.accounts;
    i.accounts = accounts;
  }

  return i;
};
*/

export const generatePartnershipListStateDataItem = (data: any) => {

  let i = {

    id: data.id,
    ikey: data.ikey,
    list_name: data.list_name,
    list_motion_name: data.list_motion_name,
   
    // main_image: data.main_image,
    // main_image_base64: data.main_image_base64,
    main_image_name: data.main_image_name,
    accounts_max_number: data.accounts_max_number,

   
    region_code: data.region_code,
    //regionDecoded: e.regionDecoded,
    province_code: data.province_code,
    //provinceDecoded: e.provinceDecoded,
    town_code: data.town_code,
    //townDecoded: e.townDecoded,
    

    status: data.status,


    created_by: data.created_by,
    created_at: data.created_at,
    updated_by: data.updated_by,
    updated_at: data.updated_at,
    deleted_by: data.deleted_by,
    deleted_at: data.deleted_at,

    type: IType.partnership_list
  } as unknown as IPartnershipList

  
  return i;
};

export const generateAccreditationStateDataItem = (data: any) => {

  let i = {

    id: data.id,
    ikey: data.ikey,

    table_ikey: data.table_ikey,
    table_name: data.table_name,
    
    accreditation_qrcode: data.accreditation_qrcode,

    created_by: data.created_by,
    created_at: data.created_at,
    // updated_by: data.updated_by,
    // updated_at: data.updated_at,
    // deleted_by: data.deleted_by,
    // deleted_at: data.deleted_at,

    // notified_by: data.notified_by,
    // notified_at: data.notified_at,
    reference: data.reference, 

    type: IType.accreditation
  } as unknown as IAccreditation

  if (data.account) {
    i.account = generateAccountStateDataItem(data.account);
  }

  if(data.print_history) {
    i.print_history = data.print_history
  }


  return i;
};

export const generateAccountManagementStateDataItem = (data: any) => {

  let i = {

    id: data.id,
    ikey: data.ikey,

    region_code: data.region_code,
    province_code: data.province_code,
    delegate_number: data.delegate_number,

    
    created_by: data.created_by,
    created_at: data.created_at,
    // updated_by: data.updated_by,
    // updated_at: data.updated_at,
    // deleted_by: data.deleted_by,
    // deleted_at: data.deleted_at,

    // notified_by: data.notified_by,
    // notified_at: data.notified_at,

    type: IType.account_management
  } as unknown as IAccountManagement

  // if (data.account) {
    
  //   i.account = data.account;
  // }


  return i;
};

export const generatePrintHistoryStateDataItem = (data: any) => {

  let i = {

    id: data.id,
    ikey: data.ikey,

    reference_ikey: data.reference_ikey,

    created_by: data.created_by,
    created_at: data.created_at,
    updated_by: data.updated_by,
    updated_at: data.updated_at,
    deleted_by: data.deleted_by,
    deleted_at: data.deleted_at,

    event_accreditation: [],

    type: IType.print_history
  } as unknown as IPrintHistory

  if (data.event_accreditation) {
    i.event_accreditation = data.event_accreditation;
    i.event_accreditation.reference = IType.event;
  }


  return i;
};

export const generateSemaphoreStateDataItem = (data: any) => {

  let i = {

    //active_event_ikey: data.active_event_ikey,

    app_section_key: data.system_configuration_value,
    status: data.system_configuration_status,

    created_by: data.created_by,
    created_at: data.created_at,
    // updated_by: data.updated_by,
    // updated_at: data.updated_at,
    // deleted_by: data.deleted_by,
    // deleted_at: data.deleted_at,

    // notified_by: data.notified_by,
    // notified_at: data.notified_at,

    type: IType.semaphore
  } as unknown as ISemaphore

  return i;
};

export const generateReportStateDataItem = (data: any) => {

  let i = {

    data: data,

    type: IType.report
  } as unknown as IReport

  return i;
};

export const generateAssociationStateDataItem = (data: any) => {

  let i = {
    id: data.id,

    Nome: data.Nome,
    Abitanti: data.Abitanti ?? null,
    Intercomunale: data.Intercomunale ?? false,
    Regione: data.Regione ?? null,
    Provincia: data.Provincia ?? null,
    Codice_Localita: data.Codice_Localita ?? null,
    Nome_Localita: data.Nome_Localita ?? null,

    created_by: data.created_by,
    created_at: data.created_at,
    updated_by: data.updated_by ?? null,
    updated_at: data.updated_at ?? null,
    deleted_by: data.deleted_by ?? null,
    deleted_at: data.deleted_at ?? null,

    type: IType.association
    
  } as unknown as IAssociation;

  return i;
  }

export const generateMembershipStateDataItem = (data: any): IMembership => {
  const i: IMembership = {
    id: data.id,
    ikey: data.ikey,

    ID_tesserato: data.ID_tesserato,

    Anno: data.Anno,
    NumeroTessera: data.NumeroTessera,
    RegioneAssociazione: data.Regione ?? null,
    ProvinciaAssociazione: data.ProvinciaAssociazione ?? null,
    Associazione: data.Associazione,
    Promotore: data.Promotore ?? null,
    Promotore2: data.Promotore2 ?? null,
    Circolo: data.Circolo ?? null,
    DataRegistrazione: data.DataRegistrazione,

    Attiva: data.Attiva,
    Giornale: data.Giornale ?? null,
    Spedita: data.Spedita,
    DataSpedizione: data.DataSpedizione ?? null,
    Ritornata: data.Ritornata,
    Presidente: data.Presidente ?? null,
    StatusFuorisede: data.StatusFuorisede ?? null,
    ScadenzaTesseramento: data.ScadenzaTesseramento ?? null,
    Tipologia: data.Tipologia ?? null,
    IncaricoIstituzionale: data.IncaricoIstituzionale ?? null,
    QuotaAdesione: data.QuotaAdesione ?? null,

    UtenteVariazione: data.UtenteVariazione ?? null,
    DataVariazione: data.DataVariazione ?? null,

    SpeditaDa: data.SpeditaDa ?? null,
    PagateMeta: data.PagateMeta,
    Nota: data.Nota ?? null,
    InteresseTematico: data.InteresseTematico ?? null,
    Restituzione50: data.Restituzione50,
    ComitatoSINO: data.ComitatoSINO === 'SI' || data.ComitatoSINO === true,
    Impegno: data.Impegno ?? null,
    gev: data.gev,
    iscrizione_gev: data.iscrizione_gev,
    Intestatario_Pagamento: data.Intestatario_Pagamento ?? null,

    created_by: data.created_by,
    updated_by: data.updated_by ?? null,
    deleted_by: data.deleted_by ?? null,

    created_at: data.created_at,
    updated_at: data.updated_at,
    deleted_at: data.deleted_at ? data.deleted_at : null,

    member: {} as IMember,
    singleRequest: {} as ISingleMembershipRequest,
    bulkRequest: {} as IBulkMembershipRequest,

    type: IType.membership,
  };

  i.member = generateMemberStateDataItem({
    ...data.member,
    memberships: [],
  });

  i.singleRequest = generateSmrStateDataItem({
    ...data.single_request,
    memberships: [],
  });

  i.bulkRequest = generateBmrStateDataItem({
    ...data.bulk_request,
    memberships: [],
  });

  return i;
};

export const generateMemberStateDataItem = (data: any) => {
  const i = {
    id: data.id,
    ID_tesserato: data.ID_tesserato,

    Nome: data.Nome,
    Cognome: data.Cognome,
    Professione: data.Professione ?? null,
    DataNascita: data.DataNascita ?? null,
    Indirizzo: data.Indirizzo ?? null,
    TelPrefisso: data.TelPrefisso ?? null,
    TelNumero: data.TelNumero ?? null,
    Cellulare: data.Cellulare ?? null,
    Citta: data.Citta ?? null,
    CAP: data.CAP ?? null,
    Provincia: data.Provincia ?? null,
    Regione: data.Regione ?? null,
    Sesso: data.Sesso ?? null,
    Email: data.Email ?? null,
    Cat_Professionale: data.Cat_Professionale ?? null,
    Nazione: data.Nazione ?? null,
    Codice_Fiscale: data.Codice_Fiscale ?? null,
    Allegato: data.Allegato ?? null,

    created_by: data.created_by,
    created_at: data.created_at,
    updated_by: data.updated_by,
    updated_at: data.updated_at,
    deleted_by: data.deleted_by,
    deleted_at: data.deleted_at,

    memberships: [] as IMembership[],

    type: IType.member,
  } as unknown as IMember

  let p = data.memberships;

  if (Array.isArray(data.memberships) && data.memberships.length > 0) {
    data.memberships.forEach((m: any) => {
      const membership = generateMembershipStateDataItem(m);
      i.memberships.push(membership);
    });
  }

  return i;
  
};

export const generateSettingTableStateDataItem = (
  data: any,
  tableType: string
): ISystemTableItem => {

  switch (tableType) {
    case 'tipologie':
      return {
        ID_Tipologia: data.ID_Tipologia,
        Tipologia: data.Tipologia ?? '',
        type: IType.systemtable,
      } as ITipologia;

    case 'professione':
      return {
        Chiave: data.Chiave,
        Chiave_Categoria: data.Chiave_Categoria,
        Descrizione: data.Descrizione ?? '',
        type: IType.systemtable,
      } as IProfessione;

    case 'categoria-professionale':
      return {
        Chiave: data.Chiave,
        Descrizione: data.Descrizione ?? '',
        professioni: Array.isArray(data.professioni)
          ? data.professioni.map((p: any) => ({
              Chiave: p.Chiave,
              Chiave_Categoria: p.Chiave_Categoria,
              Descrizione: p.Descrizione ?? '',
              type: IType.systemtable,
            } as IProfessione))
          : [],
        type: IType.systemtable,
    } as ICategoriaProfessionale;

    case 'status-fuorisede':
      return {
        ID_StatusFuorisede: data.ID_StatusFuorisede,
        StatusFuorisede: data.StatusFuorisede ?? '',
        type: IType.systemtable,
      } as IStatusFuorisede;

    case 'tipo-collaborazione':
      return {
        Key: data.Key,
        Value: data.Value ?? '',
        OrderBy: data.OrderBy ?? 0,
        type: IType.systemtable,
      } as ITipoCollaborazione;

    case 'adesione-comitato':
      return {
        Key: data.Key,
        Value: data.Value ?? '',
        OrderBy: data.OrderBy ?? 0,
        type: IType.systemtable,
      } as IAdesioneComitato;

    default:
      const item: ISystemTableItem = {};

      for (const key in data) {
        if (!Object.prototype.hasOwnProperty.call(data, key)) continue;
        const value = data[key];
        item[key] =
          typeof value === 'string' ||
          typeof value === 'number' ||
          typeof value === 'boolean' ||
          value === null
            ? value
            : String(value);
      }

      item.type = IType.systemtable;
      return item;
  }
};

export const generateSmrStateDataItem = (data: any): ISingleMembershipRequest => {

    let tipologia: number;
    if (data.Incarico !== null) {
      tipologia = 3; // Eletto
    }
    else if (data?.gev || data?.iscrizione_gev) {
      tipologia = 2; // Giovane
    }
    else {
      tipologia = 1; // Ordinario
    }


  const i = {
    ID: data.id,

    ID_tesserato: data.ID_tesserato ?? null,
    Nome: data.Nome ?? null,
    Cognome: data.Cognome ?? null,
    DataNascita: data.DataNascita ?? null,
    DataNascitaDate: data.DataNascitaDate ?? null,
    Sesso: data.Sesso ?? null,
    Professione: data.Professione ?? null,
    Citta: data.Citta ?? null,
    CAP: data.CAP ?? null,
    Provincia: data.Provincia ?? null,
    Indirizzo: data.Indirizzo ?? null,
    Email: data.Email ?? null,
    Prefisso: data.Prefisso ?? null,
    Telefono: data.Telefono ?? null,
    Cellulare: data.Cellulare ?? null,
    Nazione: data.Nazione ?? null,
    Codice_Fiscale: data.Codice_Fiscale ?? null,
    Allegato: data.fileupload ?? null,

    Associazione: data.Associazione ?? null,
    StatusFuorisede: data.FuoriSede === "Comune" ? "1" : data.FuoriSede === "Studio" ? "2" : data.FuoriSede === "Lavoro" ? "3": null,
    IncaricoIstituzionale: data.Incarico ?? null,
    QuotaAdesione: data.Quota ?? null,
    Intestatario_Pagamento: data.Intestatario_Pagamento ?? null,
    NumeroTessera: data.NumeroTessera ?? null,
    Giornale: data.Giornale ?? null,
    gev: data.gev ?? null,
    Restituzione50: data.Restituzione50 ?? null,
    ComitatoSINO: data.ComitatoSINO ?? null,
    Impegno: data.Impegno ?? null,
    iscrizione_gev: data.iscrizione_gev ?? null,
    Tipologia: tipologia,

    NuovaTessera: data.NuovaTessera ?? null,
    Pagamento: data.Pagamento ?? null,
    Rinnovo: data.Rinnovo ?? null,
    NuovoTesserato: data.NuovoTesserato ?? null,
    tmpdir: data.tmpdir ?? null,

    DataRichiesta: data.DataRichiesta ?? null,
    DataPagamento: data.DataPagamento ?? null,

    AccettataDa: data.AccettataDa ?? null,
    DataAccettazione: data.DataAccettazione ?? null,

    CancellataDa: data.CancellataDa ?? null,
    DataCancellazione: data.DataCancellazione ?? null,
    daControllare: data.daControllare ?? null,

    ControllataDa: data.ControllataDa ?? null,
    DataControllo: data.DataControllo ?? null,

    created_at: data.created_at ?? null,
    updated_at: data.updated_at ?? null,
    deleted_at: data.deleted_at ?? null,

    anno_ultima_tessera: data.anno_ultima_tessera ?? null,
    numero_ultima_tessera: data.numero_ultima_tessera ?? null,

    payment_id: data.payment_id ?? null,

    type: IType.smr,
  } as unknown as ISingleMembershipRequest;

  return i;
};

export const generateBmsStateDataItem = (data: any): IBulkMembershipStock => {
  const i: IBulkMembershipStock = {
    Tesseratore_StockID: data.Tesseratore_StockID,

    Descrizione_StockID: data.Descrizione_StockID ?? null,
    Anno_Tesseramento: data.Anno_Tesseramento ?? null,

    Tesseratore_Regione: data.Tesseratore_Regione ?? null,
    Tesseratore_Provincia: data.Tesseratore_Provincia ?? null,
    Intestatario_Pagamento: data.Intestatario_Pagamento ?? null,
    Tesseratore_Email: data.Tesseratore_Email ?? null,
    Tesseratore_Descrizione: data.Tesseratore_Descrizione ?? null,
    Tesseratore_Stock_Data: data.Tesseratore_Stock_Data ?? null,

    Stock_Value: data.Stock_Value ?? null,

    pending_requests_count: data.pending_requests_count ?? 0,
    pending_requests_value: data.pending_requests_value ?? 0,

    accepted_requests_count: data.accepted_requests_count ?? 0,
    accepted_requests_value: data.accepted_requests_value ?? 0,

    cancelled_requests_count: data.cancelled_requests_count ?? 0,
    cancelled_requests_value: data.cancelled_requests_value ?? 0,

    total_requests_count: data.total_requests_count ?? 0,
    total_stocks: data.total_stocks ?? 0,

    created_at: data.created_at ?? null,
    updated_at: data.updated_at ?? null,
    deleted_at: data.deleted_at ?? null,

    type: IType.bms,
  };

  return i;
};

export const generateBmrStateDataItem = (data: any): IBulkMembershipRequest => {

    let tipologia: number;
    if (data.Incarico !== null) {
      tipologia = 3; // Eletto
    }
    else if (data?.gev || data?.iscrizione_gev) {
      tipologia = 2; // Giovane
    }
    else {
      tipologia = 1; // Ordinario
    }
    
  const i: IBulkMembershipRequest = {
    ID: data.id,

    Tesseratore_StockID: data.Tesseratore_StockID ?? null,
    Tesseratore_Email: data.Tesseratore_Email ?? null,
    Tesseratore_Stock_Data: data.Tesseratore_Stock_Data ?? null,
    Tesseratore_Descrizione: data.Tesseratore_Descrizione ?? null,
    Stock_Value: data.Stock_Value ?? null,
    Stock_Detail_Value: data.Stock_Detail_Value ?? null,

    ID_tesserato: data.ID_tesserato ?? null,
    Nome: data.Nome ?? null,
    Cognome: data.Cognome ?? null,
    DataNascita: data.DataNascita ?? null,
    DataNascitaDate: data.DataNascitaDate ?? null,
    Sesso: data.Sesso ?? null,
    Professione: data.Professione ?? null,
    Citta: data.Citta ?? null,
    CAP: data.CAP ?? null,
    Provincia: data.Provincia ?? null,
    Indirizzo: data.Indirizzo ?? null,
    Email: data.Email ?? null,
    Prefisso: data.Prefisso ?? null,
    Telefono: data.Telefono ?? null,
    Cellulare: data.Cellulare ?? null,
    Nazione: data.Nazione ?? null,
    Codice_Fiscale: data.Codice_Fiscale ?? null,
    fileupload: data.fileupload ?? null,

    Associazione: data.Associazione ?? null,
    StatusFuorisede: data.FuoriSede === "Comune" ? "1" : data.FuoriSede === "Studio" ? "2" : data.FuoriSede === "Lavoro" ? "3": null,
    Incarico: data.Incarico ?? null,
    Quota: data.Quota ?? null,
    Intestatario_Pagamento: data.Intestatario_Pagamento ?? null,
    NumeroTessera: data.NumeroTessera ?? null,
    Giornale: data.Giornale ?? null,
    gev: data.gev ?? null,
    Restituzione50: data.Restituzione50 ?? null,
    ComitatoSINO: data.ComitatoSINO ?? null,
    Impegno: data.Impegno ?? null,
    iscrizione_gev: data.iscrizione_gev ?? null,
    Tipologia: tipologia,

    NuovaTessera: data.NuovaTessera ?? null,
    Pagamento: data.Pagamento ?? null,
    Rinnovo: data.Rinnovo ?? null,
    NuovoTesserato: data.NuovoTesserato ?? null,
    tmpdir: data.tmpdir ?? null,

    DataRichiesta: data.DataRichiesta ?? null,
    DataPagamento: data.DataPagamento ?? null,

    AccettataDa: data.AccettataDa ?? null,
    DataAccettazione: data.DataAccettazione ?? null,

    CancellataDa: data.CancellataDa ?? null,
    DataCancellazione: data.DataCancellazione ?? null,
    daControllare: data.daControllare ?? null,

    ControllataDa: data.ControllataDa ?? null,
    DataControllo: data.DataControllo ?? null,

    created_at: data.created_at ?? null,
    updated_at: data.updated_at ?? null,
    deleted_at: data.deleted_at ?? null,

    anno_ultima_tessera: data.anno_ultima_tessera ?? null,
    numero_ultima_tessera: data.numero_ultima_tessera ?? null,

    type: IType.bmr,
  };

  return i;
};

export const generateMembershipRequestStateDataItem = (data: any): IMembershipRequest => {

    let tipologia: number;
    if (data.Incarico !== null) {
      tipologia = 3; // Eletto
    }
    else if (data?.gev || data?.iscrizione_gev) {
      tipologia = 2; // Giovane
    }
    else {
      tipologia = 1; // Ordinario
    }
    
  const i: IMembershipRequest = {
    ID: data.id,

    Tesseratore_StockID: data.Tesseratore_StockID ?? null,
    Tesseratore_Email: data.Tesseratore_Email ?? null,
    Tesseratore_Stock_Data: data.Tesseratore_Stock_Data ?? null,
    Tesseratore_Descrizione: data.Tesseratore_Descrizione ?? null,
    Stock_Value: data.Stock_Value ?? null,
    Stock_Detail_Value: data.Stock_Detail_Value ?? null,

    ID_tesserato: data.ID_tesserato ?? null,
    Nome: data.Nome ?? null,
    Cognome: data.Cognome ?? null,
    DataNascita: data.DataNascita ?? null,
    DataNascitaDate: data.DataNascitaDate ?? null,
    Sesso: data.Sesso ?? null,
    Professione: data.Professione ?? null,
    Citta: data.Citta ?? null,
    CAP: data.CAP ?? null,
    Provincia: data.Provincia ?? null,
    Indirizzo: data.Indirizzo ?? null,
    Email: data.Email ?? null,
    Prefisso: data.Prefisso ?? null,
    Telefono: data.Telefono ?? null,
    Cellulare: data.Cellulare ?? null,
    Nazione: data.Nazione ?? null,
    Codice_Fiscale: data.Codice_Fiscale ?? null,
    fileupload: data.fileupload ?? null,

    Associazione: data.Associazione ?? null,
    StatusFuorisede: data.FuoriSede === "Comune" ? "1" : data.FuoriSede === "Studio" ? "2" : data.FuoriSede === "Lavoro" ? "3": null,
    Incarico: data.Incarico ?? null,
    Quota: data.Quota ?? null,
    Intestatario_Pagamento: data.Intestatario_Pagamento ?? null,
    NumeroTessera: data.NumeroTessera ?? null,
    Giornale: data.Giornale ?? null,
    gev: data.gev ?? null,
    Restituzione50: data.Restituzione50 ?? null,
    ComitatoSINO: data.ComitatoSINO ?? null,
    Impegno: data.Impegno ?? null,
    iscrizione_gev: data.iscrizione_gev ?? null,
    Tipologia: tipologia,

    NuovaTessera: data.NuovaTessera ?? null,
    Pagamento: data.Pagamento ?? null,
    Rinnovo: data.Rinnovo ?? null,
    NuovoTesserato: data.NuovoTesserato ?? null,
    tmpdir: data.tmpdir ?? null,

    DataRichiesta: data.DataRichiesta ?? null,
    DataPagamento: data.DataPagamento ?? null,

    AccettataDa: data.AccettataDa ?? null,
    DataAccettazione: data.DataAccettazione ?? null,

    CancellataDa: data.CancellataDa ?? null,
    DataCancellazione: data.DataCancellazione ?? null,
    daControllare: data.daControllare ?? null,

    ControllataDa: data.ControllataDa ?? null,
    DataControllo: data.DataControllo ?? null,

    created_at: data.created_at ?? null,
    updated_at: data.updated_at ?? null,
    deleted_at: data.deleted_at ?? null,

    Tipo: data.Tipo ?? null,

    type: IType.membershipRequest,
  };

  return i;
};

export const generateEmailProvinceStateDataItem = (data: any): IEmailProvince => {

  const i: IEmailProvince = {

    Sigla_Provincia: data.Sigla_Provincia ?? null,
    Provincia: data.Provincia,
    Regione: data.Regione ?? null,
    Sigla_Regione: data.Sigla_Regione ?? null,
    Email: data.Email ?? null,
    Email_2: data.Email_2 ?? null,
    Last_Year: data.Last_Year ?? null,
    Last_Number: data.Last_Number ?? null,

    created_at: data.created_at ?? null,
    updated_at: data.updated_at ?? null,

    type: IType.emailProvince,
  };

  return i;

};

export const generateEmailRegionStateDataItem = (data: any): IEmailRegion => {

  const i: IEmailRegion = {
    Sigla_Regione: data.Sigla_Regione ?? null,
    Regione: data.Regione,
    Order_By: data.Order_By ?? null,

    Email: data.Email ?? null,
    Email_2: data.Email_2 ?? null,
    Email_3: data.Email_3 ?? null,

    Last_Year: data.Last_Year ?? null,
    Last_Number: data.Last_Number ?? null,

    created_at: data.created_at ?? null,
    updated_at: data.updated_at ?? null,

    province: [],

    type: IType.emailRegion,
  };

  let p = data.province;

  if (Array.isArray(data.province) && data.province.length > 0) {
    data.province.forEach((p: any) => {
      const provinceItem: IEmailProvince = generateEmailProvinceStateDataItem(p);
      i.province.push(provinceItem);
    });
  }

  return i;
};